const articles = [
  {
    tag: "辨识技巧",
    title: "如何一眼辨别水彩晕染画风",
    desc: "水彩晕染的画面边缘通常柔和、没有生硬色块，色彩之间自然过渡并保留纸张的颗粒肌理。人物轮廓常被颜料“洇开”一些，整体给人通透、轻盈的呼吸感。",
  },
  {
    tag: "题材匹配",
    title: "为什么水墨国风适合慢热情感线",
    desc: "水墨讲究留白与克制，用笔轻重便能传达欲言又止的情绪。这种“不把话说满”的叙事方式，与古风题材里隐忍深情的感情线天然契合，越品越有韵味。",
  },
  {
    tag: "画风选择",
    title: "厚涂光影与电影感分镜怎么选",
    desc: "若你喜欢立体质感、氛围浓烈的画面，厚涂光影更合适；若你偏爱镜头调度与叙事节奏，电影感分镜能带来更强的沉浸体验。两者都适合张力十足的都市与悬疑题材。",
  },
  {
    tag: "新手入门",
    title: "第一次追 BL 漫画，选哪种画风？",
    desc: "入门推荐清新淡彩与赛璐璐上色——线条干净、色彩明快，读起来轻松无压力。进阶后再尝试水彩晕染与水墨国风，更能体会画风为故事带来的氛围加成。",
  },
];

export default function Wiki() {
  return (
    <section id="wiki" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="text-xs font-medium tracking-widest text-primary-600">画风百科</p>
            <h2 className="mt-2 font-heading text-2xl text-foreground-900 md:text-4xl">读懂画风，看画更懂故事</h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            画风不只是“好看”，它参与叙事、塑造氛围。这几篇短文帮你快速理解不同画风的特征与适配题材。
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {articles.map((a, i) => (
            <article key={a.title} className="flex flex-col rounded-lg border border-background-200 bg-background-100/60 p-5 transition hover:border-accent-300">
              <div className="flex items-center justify-between">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className={`${["ri-water-flash-line", "ri-ink-bottle-line", "ri-film-line", "ri-book-open-line"][i]} text-lg`} aria-hidden="true"></i>
                </span>
                <span className="whitespace-nowrap rounded-full bg-background-200 px-2.5 py-0.5 text-xs text-foreground-600">{a.tag}</span>
              </div>
              <h3 className="mt-4 text-sm font-semibold leading-snug text-foreground-900 md:text-base">{a.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{a.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}